﻿export const BrowseJobsOverlay = () => {
    const headerSearchInput = document.querySelector(
        ".main-site-header .attrax-form-item__input"
    );
    const closeBtn = document.querySelector(".search-overlay__close-btn");
    const mobileSearchOpen = document.querySelector(
        ".main-site-header__mobile-open-search"
    );

    if (!headerSearchInput || !closeBtn || !mobileSearchOpen) {
        return;
    }

    headerSearchInput.addEventListener("click", () => {
        openOverlay();
    });

    headerSearchInput.addEventListener("focus", () => {
        openOverlay();
    });

    mobileSearchOpen.addEventListener("click", () => {
        openOverlay();
    });

    closeBtn.addEventListener("click", () => {
        closeOverlay();
    });
};

const openOverlay = () => {
    const overlay = document.querySelector(".search-overlay");

    if (!overlay) {
        return;
    }

    if (!overlay.classList.contains("search-overlay--open")) {
        overlay.classList.add("search-overlay--open");
    }
};

const closeOverlay = () => {
    const overlay = document.querySelector(".search-overlay");

    if (!overlay) {
        return;
    }

    if (overlay.classList.contains("search-overlay--open")) {
        overlay.classList.remove("search-overlay--open");
    }
};
